var $ = require('jquery');
require('owlSlider');
var self = {};
var apSpeed = 50000;

self.initialise = function() {
  $('.owl-carousel').owlCarousel({
    autoPlay: 10000,
    paginationSpeed: 3000,
    nav: true,
    items: 1,
    singleItem: true,
    navigation: true,
    addClassActive: true,
  });

  $('.owl-carousel2').owlCarousel({
    autoPlay: 10000,
    paginationSpeed: 3000,
    items: 5,
    itemsScaleUp: false,
    loop: true,
    responsiveClass: true,
    itemsDesktop: [1199, 5],
    itemsDesktopSmall: [980, 3],
    itemsTablet: [768, 2],
    itemsMobile: [479, 1],
  });

  $('#testimonial-carousel').owlCarousel({
    autoPlay: 10000,
    paginationSpeed: 3000,
    items: 1,
    itemsDesktop: 1,
    itemsDesktopSmall: 1,
    itemsTablet: 1,
    itemsMobile: 1,
    loop: true,
  });

  $('.faq-slider').owlCarousel({
    autoPlay: false,
    nav: true,
    items: 1,
    singleItem: true,
    navigation: true,
    addClassActive: true,
    itemsTablet: [768, 2],
    itemsMobile: [479, 1],
  });

  $('.faq-slider').owlCarousel({
    autoPlay: false,
    nav: true,
    items: 1,
    singleItem: true,
    navigation: true,
    addClassActive: true,
    itemsTablet: [768, 2],
    itemsMobile: [479, 1],
  });

  /* Resize the Carousel and equalise the heights of elements within */
  function SetMaxHeight() {
    $('#testimonial-carousel blockquote').css('height', '');

    setTimeout(function() {
      var maxHeight = 0;
      $('#testimonial-carousel blockquote').each(function() {
        if ($(this).outerHeight() > maxHeight) {
          maxHeight = $(this).outerHeight();
        }
      });

      $('#testimonial-carousel').css('height', maxHeight + 'px');
      $('#testimonial-carousel blockquote').css('height', maxHeight + 'px');
    }, 1000);
  }

  SetMaxHeight();
  $(window).resize(SetMaxHeight);
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/call-owl.js